import  { useState } from 'react';
import { Phone, MapPin, Mail} from 'lucide-react';

// Componenta ProtectedEmail
const ProtectedEmail = ({ 
  className = "",
  showIcon = true,
  variant = "copyable",
  buttonText = "Email",
  iconColor = "text-teal-400" 
}) => {
  const [copied, setCopied] = useState(false);
  
  const encodedEmail = "Y29udGFjdEB2Z2x0cmFuc2V4cHJlc3MuY29t";
  const emailParts = {
    user: "contact",
    domain: "vgltransexpress",
    extension: "com"
  };

  const getDecodedEmail = () => {
    try {
      return atob(encodedEmail);
    } catch (e) {
      return `${emailParts.user}@${emailParts.domain}.${emailParts.extension}`;
    }
  };

  const handleObfuscatedClick = () => {
    const email = getDecodedEmail();
    window.location.href = `mailto:${email}`;
  };

  const copyToClipboard = async () => {
    const email = getDecodedEmail();
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      const textArea = document.createElement('textarea');
      textArea.value = email;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  if (variant === "split") {
    return (
      <button 
        onClick={handleObfuscatedClick}
        className={`group flex items-center transition-all duration-300 cursor-pointer ${className}`}
        aria-label="Trimite email"
      >
        {showIcon && (
          <div className="mr-4 p-2 sm:p-3 bg-gradient-to-br from-blue-500/20 to-teal-500/20 rounded-lg sm:rounded-xl group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
            <Mail className={`w-6 h-6 sm:w-8 sm:h-8 ${iconColor}`} />
          </div>
        )}
        <div className="min-w-0 flex-1">
          <div className="font-bold text-base sm:text-lg mb-1">{buttonText}</div>
          <div className="text-white text-base sm:text-lg break-words">
            {emailParts.user}@{emailParts.domain}.{emailParts.extension}
          </div>
        </div>
      </button>
    );
  }

  return null;
};

// Componenta principală
const ContactInfoSection = () => {
  const contactItems = [
    {
      icon: <Phone className="w-6 h-6 sm:w-8 sm:h-8 text-blue-400" />,
      title: 'Telefon',
      content: '+40 745 586 183',
      isComponent: false
    },
    {
      icon: <MapPin className="w-6 h-6 sm:w-8 sm:h-8 text-emerald-400" />,
      title: 'Adresă',
      content: 'Dej, str. Valcele, nr.38A',
      subtitle: 'Sediul central',
      isComponent: false
    }
  ];

  return (
    <div className="bg-gradient-to-br from-slate-900 to-slate-800 p-8">
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-white text-center mb-8">
        Informații de Contact
      </h1>
        
        <div className="space-y-6 sm:space-y-8">
          {/* Render obiectele normale */}
          {contactItems.map((item, index) => (
            <div key={index} className="group flex items-start p-4 sm:p-6 bg-white/5 backdrop-blur-sm rounded-xl sm:rounded-2xl hover:bg-white/10 transition-all duration-300 cursor-pointer">
              <div className="mr-4 sm:mr-6 p-2 sm:p-3 bg-gradient-to-br from-blue-500/20 to-teal-500/20 rounded-lg sm:rounded-xl group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                {item.icon}
              </div>
              <div className="min-w-0 flex-1">
                <div className="font-bold text-base sm:text-lg mb-1">{item.title}</div>
                <div className="text-white text-base sm:text-lg mb-1 break-words">{item.content}</div>
                {item.subtitle && <div className="text-slate-400 text-sm">{item.subtitle}</div>}
              </div>
            </div>
          ))}
          
          {/* Render componenta ProtectedEmail separat */}
          <ProtectedEmail
            variant="split"
            className="p-4 sm:p-6 bg-white/5 backdrop-blur-sm rounded-xl sm:rounded-2xl hover:bg-white/10 transition-all duration-300 cursor-pointer"
            buttonText="Email"
            iconColor="text-teal-400"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactInfoSection;